import each from 'lodash/each';

import { 
  toStructuredStandardPageContentItem
} from './transform_standard_page_content_item.js';


export const toStructuredPageContentItems = (pageContentItems, sectionsById, menuItemsById)=> {
  // pageContentItems should be only standard page items, not the config item

  const pageContentItemsByUuid = {};
  
  each(pageContentItems, (item)=> {
    const structuredItem = toStructuredStandardPageContentItem(item, sectionsById, menuItemsById);
    pageContentItemsByUuid[structuredItem.uuid] = structuredItem;
  });

  return { pageContentItemsByUuid };
};
